export default "__VITE_ASSET__f3dfdc9c__"